/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {AngularResourceListManager} from '../../common/controller/angular-resource-list-manager';
import {ApiErrorHandlerService} from '../../common/directives/error/api-error-handler.service';
import {AuthHttpInterceptorService} from '../../../components/auth/auth-http-interceptor.service';
import {AdnHttpService} from '../../../components/util/adn-http.service';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {WINDOW} from '../../angular-platform-providers';

@Component({
  standalone: false,
  selector: 'adn-cdn-upload-route-page',
  template: `
    <adn-cdn-upload-list-page
      *ngIf="list"
      [list]="list">
    </adn-cdn-upload-list-page>
  `
})
export class CdnUploadRoutePageComponent implements OnInit, OnDestroy {
  list: any;

  private listManager: AngularResourceListManager;

  constructor(
    private readonly AdnHttp: AdnHttpService,
    private readonly authHttpInterceptor: AuthHttpInterceptorService,
    private readonly ApiErrorHandler: ApiErrorHandlerService,
    @Inject(LocalUserProfile) private localUserProfile: any,
    @Inject(WINDOW) private window: any,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.listManager = new AngularResourceListManager({
      AdnHttp: this.AdnHttp,
      authHttpInterceptor: this.authHttpInterceptor,
      ApiErrorHandler: this.ApiErrorHandler,
      window: this.window,
      localUserProfile: this.localUserProfile,
      ngZone: this.ngZone
    }, {
      resourcePath: 'cdnassets',
      listId: 'fullCdnUploadList',
      defaultOrderByParam: 'width'
    });
    this.list = this.listManager.list;
    this.listManager.load();
  }

  ngOnDestroy(): void {
    this.listManager?.destroy();
  }
}
